import React from 'react';
import { Header } from './Header';
import { KPIRow } from './KPIRow';
import { CostDistribution } from './CostDistribution';
import { FreightPanel } from './FreightPanel';
import { DiscountsPanel } from './DiscountsPanel';
import { SidePanel } from './SidePanel';
import { Footer } from './Footer';
import { ScenarioTabs } from './ScenarioTabs';
export function TilbudsOverblik() {
  return <div className="w-full max-w-[1600px] mx-auto" data-id="element-155">
      <Header data-id="element-156" />
      <main className="px-6 pb-8" data-id="element-157">
        <ScenarioTabs data-id="element-158" />
        <div className="flex gap-6 mt-6" data-id="element-159">
          <div className="flex-1" data-id="element-160">
            <KPIRow data-id="element-161" />
            <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-162">
              <CostDistribution data-id="element-163" />
              <FreightPanel data-id="element-164" />
            </div>
            <div className="mt-6" data-id="element-165">
              <DiscountsPanel data-id="element-166" />
            </div>
          </div>
          <div className="w-80 hidden xl:block" data-id="element-167">
            <SidePanel data-id="element-168" />
          </div>
        </div>
      </main>
      <Footer data-id="element-169" />
    </div>;
}